var exports = {
  "kL": "xa15a2ab7--6c13ee--container",
  "QZ": "xa15a2ab7--6c13ee--phones",
  "pq": "xa15a2ab7--6c13ee--info",
  "Kk": "xa15a2ab7--6c13ee--icon",
};

module.exports = exports;
